import { render, staticRenderFns } from "./home_news_roll.vue?vue&type=template&id=8f4e7256&scoped=true"
import script from "./home_news_roll.vue?vue&type=script&lang=js"
export * from "./home_news_roll.vue?vue&type=script&lang=js"
import style0 from "./home_news_roll.vue?vue&type=style&index=0&id=8f4e7256&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4e7256",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\java\\project\\kaixinshequ-java\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f4e7256')) {
      api.createRecord('8f4e7256', component.options)
    } else {
      api.reload('8f4e7256', component.options)
    }
    module.hot.accept("./home_news_roll.vue?vue&type=template&id=8f4e7256&scoped=true", function () {
      api.rerender('8f4e7256', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/home_news_roll.vue"
export default component.exports